class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.activeElement = null;
    this.autoCloseTimeout = null;

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );

      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener("click", this.close.bind(this))
      );
    }
  }

  open() {
    if (!this.notification) return;

    clearTimeout(this.autoCloseTimeout);

    this.notification.classList.add("animate", "active");
    this.notification.setAttribute("aria-hidden", "false");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);

    this.autoCloseTimeout = setTimeout(() => {
      this.close();
    }, 5000);
  }

  close() {
    if (!this.notification) return;

    clearTimeout(this.autoCloseTimeout);

    this.notification.classList.remove("active");
    this.notification.setAttribute("aria-hidden", "true");
    document.body.removeEventListener("click", this.onBodyClick);

    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    if (!parsedState) return;

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (element && parsedState.sections && parsedState.sections[section.id]) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.updateCartIconCount(parsedState.sections);
    this.updateCartDrawer();
    this.rebindCloseButtons();

    if (this.header && typeof this.header.reveal === "function") {
      this.header.reveal();
    }

    this.open();
  }

  rebindCloseButtons() {
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.removeEventListener("click", this.close.bind(this));
      closeButton.addEventListener("click", () => this.close());
    });
  }

  updateCartIconCount(sections) {
    if (!sections || !sections["cart-icon-bubble"]) return;

    const parsed = new DOMParser().parseFromString(
      sections["cart-icon-bubble"],
      "text/html"
    );
    const newBubble = parsed.querySelector(".cart-count-bubble");
    const currentBubble = document.querySelector(
      "#cart-icon-bubble .cart-count-bubble"
    );

    if (newBubble && currentBubble) {
      currentBubble.textContent = newBubble.textContent;
      currentBubble.style.display = newBubble.textContent ? "flex" : "none";
    } else if (newBubble && !currentBubble) {
      const cartIcon = document.getElementById("cart-icon-bubble");
      if (cartIcon) {
        cartIcon.insertAdjacentHTML("beforeend", newBubble.outerHTML);
      }
    }
  }

  updateCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.fetchAndRenderCart === "function") {
      cartDrawer.fetchAndRenderCart();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
        selector: ".cart-notification__links",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : "";
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
